<template>
  <div class="doc-api-page">
    <div class="content-body">
      <div class="part-title">
        <span>通知中心</span>
      </div>
      <div class="table-div hover-bg" style="position: absolute;left: 48px;right: 50px;padding-top: 71px;">
        <el-table
                :data="apiList"
                :show-header="false"
                size="mini"
                style="width: 100%"
                class="no-table_row"
        >
          <el-table-column prop="title" label="标题" width="800">
            <template slot-scope="scope">
              <div @click="openDetail(scope.row)">
                <span :class="[scope.row.status === 1 ? 'text-nofify on' : 'text-read']">
              <span :class="[scope.row.status === 1 ? 'icon' : '']"></span>
              {{scope.row.title}}
              </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="获取时间" width="350">
            <template slot-scope="scope">
            <div @click="openDetail(scope.row)">
            <span :class="[scope.row.status === 1 ? 'text-nofify on' : 'text-read']">
                {{scope.row.createdAt}}
            </span>
            </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row class="pagination-box" v-if="totalSum > 10">
          <el-pagination
                  class="paging"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10]"
                  :current-page.sync="pageNo"
                  :page-size="pageSize"
                  :total="totalSum"
                  layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </el-row>
      </div>
    </div>
  </div>

</template>

<script>
import {commonJsonParse} from '../../assets/js/common'
import HllJsonBox from '../common/hll-json-box'
import HllDoc from '../common/hll-doc'
export default {
    name: 'messageList',
    data() {
      return {
        messageId: '',
        pageSize: 10,
        pageNo: 1,
        totalSum: 0,
        apiList: [] // 授权的api列表
      }
    },
    computed: {
      // 遍历查找api页面的菜单id 用于跳转详情时使用
      apiMenuId() {
        let apiMenuId = '';
        let menuList = this.$store.state.app.menuList;
        menuList.forEach(val => {
          if(val.link_url.indexOf('doc/api') !== -1) {
            apiMenuId = val.id;
          }
        });
        return apiMenuId;
      }
    },
    mounted() {
      this.handleCurrentChange(1);
    },
    methods: {

      // 更新为已读
      updateMessageUser(item) {
        this.$axios.post("/ajax/message/update/isread", {
          messageUserId: item.id
        }).then(res => {
          //调用查询未读数量接口
          this.queryUnReadCount(item);
        });
      },
      // 更新为已读
      queryUnReadCount(item) {
        this.$axios.post("/ajax/message/unread/count", {
        }).then(res => {
          this.$store.state.app.unReadCount=res.data.data;
        });
      },

      // 打开详情
      openDetail(item) {
        this.$router.push({
          path: '/message/detail',
          query: {
            messageId: item.id,
          }
        });
        if(item.status===1){
          this.updateMessageUser(item);
        }
      },
      handleSizeChange(size) {
        this.pageNo = 1;
        this.pageSize = size;
        this.getListData();
      },
      handleCurrentChange(index) {
        this.pageNo = index;
        this.getListData();
      },
      // 获取数据列表
      getListData() {

        // this.apiList =  [{'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':2,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //   {'status':1,'content':'ce','created_at':'2020-08-13 12:23:45'},
        //
        // ];
        // this.totalSum = 10;
        this.$axios.post("/ajax/message/list", {
          ...this.searchObj,
          app_id: this.appId,
          page_size: this.pageSize,
          page_no: this.pageNo
        }).then(res => {
          this.apiList = res.data.data.list || [];
          this.totalSum = parseInt(res.data.data.total);
        });
      },

    }
  }
</script>

<style lang="scss">

  .doc-table-box {
    .el-table--mini,
    .el-table--small,
    .el-table__expand-icon {
      font-size: 13px;
    }
    .el-table__body {
      width: 100%;
    }
    .el-table__placeholder {
      margin-left: 1px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        top: -14px;
        left: 50%;
        margin-left: -1px;
        width: 0;
        height: 20px;
        border-left: 1px dashed #ccc;
      }
      &+.el-table__placeholder {
        display: none;
      }
    }
    .el-table__expand-icon {
      margin-right: 1px !important;
    }
  }

</style>
<style lang="scss" scoped>
  .doc-api-page {
    width: 1170px;
    padding: 0 0 30px;
    margin: 0 auto;
  }
  .page-title {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-size: 18px;
    color: #212121;
    text-align: center;
    margin: 24px 0;
  }
  .content-body {
    position: relative;
    min-height: 500px;
    margin-top: 25px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    .part-title {
      width: 91.5%;
      line-height: 35px;
      color: #424456;
      font-size: 15px;
      padding-bottom: 15px;
      padding-top: 20px;
      border-bottom: 1px solid #F2F2F2;
      font-weight: bold;
      position: absolute;
      left: 52px;
    }
    .icon{
      /*width:20px;*/
      /*border-radius:40px;*/
      /*background-color:red;*/
      /*margin-right:5px;*/
      /*color:#fff;*/
      width: 8px;
      height: 8px;
      // border: 1px solid #aaaaaa;
      border-radius: 8px;
      background-color: #f16622;
      vertical-align: middle;
      position: absolute;
      left: 4px;
      top: 7px;
    }
    .notify-detail{
      position: absolute;
      left: 81px;
      top:26px;
    }
  }
  .no-data-box {
    line-height: 30px;
    text-align: center;
    color: #666;
    font-size: 13px;
  }
  .api-list-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 237px;
    height: 100%;
    padding-top: 20px;
    background: #F4F5F6;
    box-sizing: border-box;
    .app-list-item {
      width: 100%;
      min-height: 40px;
      line-height: 18px;
      color: #212121;
      font-size: 14px;
      padding: 11px 20px 11px 20px;
      border-left: 3px solid transparent;
      box-sizing: border-box;
      cursor: pointer;
      &.active {
        color: #F16622;
        background: #fff;
        border-left-color: #F16622;
      }
    }
  }
  .api-content-box {
    width: 100%;
    padding: 22px 25px 23px 132px;
    box-sizing: border-box;
    .part-content {
      width: 100%;
      padding: 15px 3px 20px 5px;
      box-sizing: border-box;
    }
    .info-row {
      color: #212121;
      font-size: 14px;
      line-height: 24px;
      .info-label {
        display: inline-block;
        width: 90px;
        vertical-align: top;
      }
      .info-value {
        display: inline-block;
        width: 600px;
        vertical-align: top;
        color: #666;
      }
      .info-tag {
        display: inline-block;
        width: 60px;
        height: 24px;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        background: #E4E6F4;
        border-radius: 2px;
        transform: scale(.88);
        transform-origin: left;
        margin-right: -5px;
      }
      .tag-position-top {
        position: relative;
        top: -1px;
      }
    }
    .json-box {
      padding: 15px;
      max-height: 520px;
      font-size: 13px;
      line-height: 15px;
      background: #F7F7F7;
      box-sizing: border-box;
      overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/message/index.vue